import {
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import {
  MenuToggleCarmiProps,
  MenuToggleDefinition,
  MenuTogglePlatformProps,
} from '../MenuToggle.types';
import { props as viewerPropsMapper } from './MenuToggle.mapper';

const props = composeMapper<
  MenuTogglePlatformProps,
  MenuToggleDefinition,
  MenuToggleCarmiProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    return {
      ...viewerProps,
      isOpen: deps.compPreviewState
        ? deps.compPreviewState === 'open'
        : viewerProps.isOpen,
      previewWrapperProps: {
        compPreviewState: deps.compPreviewState,
      },
    };
  },
);

type MenuTogglePreviewStyles = { position?: string; zIndex?: string };

const css = withCompPreviewInfo<
  MenuTogglePreviewStyles,
  MenuToggleDefinition
>()(
  ['renderFixedPositionContainers', 'shouldResetTinyMenuZIndex'],
  ({ renderFixedPositionContainers, shouldResetTinyMenuZIndex }) => {
    const styles: MenuTogglePreviewStyles = {};
    if (shouldResetTinyMenuZIndex) {
      styles.zIndex = 'auto';
    }
    if (!renderFixedPositionContainers) {
      styles.position = 'absolute';
    }
    return styles;
  },
);

export default createComponentPreviewMapperModel({
  props,
  css,
});
